(function ($, Drupal, drupalSettings, once) {
  'use strict';

  (function ($) {
    $.QueryString = (function (a) {
      if (a === '') {return {};}
      var b = {};
      for (var i = 0; i < a.length; ++i) {
        var p = a[i].split('=', 2);
        if (p.length !== 2) {continue;}
        if (b[p[0]]) {continue;}
        b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
      }
      return b;
    })(window.location.search.substr(1).split('&'));
  })(jQuery);

  function setMultiWithChildren(select, value) {
    var inParent = false;
    var toSelect = [];
    select.val([]);
    select.find('option').each(function () {
      // Convert both values to strings for consistent comparison
      if (String($(this).val()) === String(value)) {
        toSelect.push($(this).val());
        inParent = true;
        return;
      }
      if (inParent) {
        if ($(this).text().charAt(0) === '-') {
          toSelect.push($(this).val());
          return;
        }
        else {
          inParent = false;
          return;
        }
      }
    });
    select.val(toSelect);
  }

  // Debounce function
  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
  }

  Drupal.behaviors.calendar = {
    setHidden: function (name, value) {
      if ($('form.views-exposed-form :input[name=' + name + ']').length === 0) {
        $('<input type="hidden" name="' + name + '" value="' + value + '">').appendTo($('form.views-exposed-form'));
      }
      else {
        $('form.views-exposed-form :input[name=' + name + ']').val(value);
      }
    },
    setURL: function () {
      if (history.pushState) {
        window.history.pushState({path: this.getURL()}, '', this.getURL());
      }
    },
    getURL: function () {
      var url = ''; // $('form.views-exposed-form :input[value!=""]').serialize();
      // Check region.
      if ($('form.views-exposed-form :input[name^=region]').val().length > 0) {
        url += '&region=' + $('.form-item-location .pselect-display-value').html();
        this.setHidden('region', $('.form-item-location .pselect-display-value').html());
      }
      // Check subregion.
      if ($('form.views-exposed-form :input[name^=subregion_1]').val() !== null) {
        if ($('form.views-exposed-form :input[name^=subregion]').val().length > 0) {
          url += '&subregion=' + $('.form-item-location .pselect-display-value').html();
          this.setHidden('subregion', $('.form-item-location .pselect-display-value').html());
        }
      }
      // Check city.
      if ($('form.views-exposed-form :input[name*=city]').val().length > 0) {
        url += '&city=' + $('.form-item-location .pselect-display-value').html();
        this.setHidden('city', $('.form-item-location .pselect-display-value').html());
      }

      // Check start date.
      if ($('form.views-exposed-form :input[name*=start_date]').val()) {
        url += '&start_date=' + $('.form-item-start-date input').val();
        this.setHidden('start-date', $('.form-item-start-date input').val());
      }

      // Check end date.
      if ($('form.views-exposed-form :input[name*=end_date]').val()) {
        url += '&end_date=' + $('.form-item-end-date input').val();
        this.setHidden('end-date', $('.form-item-end-date input').val());
      }

      // Check category.
      if ($('form.views-exposed-form :input[name*=content_category]').val().length > 0 && $('form.views-exposed-form :input[name*=content_category]').val()[0] !== '0') {
        url += '&category=' + $('form.views-exposed-form :input[name*=content_category]').val()[0];
        this.setHidden('category', $('form.views-exposed-form :input[name*=content_category]').val()[0]);
      }
      // Check family friendly.
      if ($('form.views-exposed-form :input[name*=family]').val() === '1') {
        url += '&family_friendly=1';
        this.setHidden('family_friendly', 1);
      }

      // Check live music.
      if ($('form.views-exposed-form :input[name*=live]').val() === '1') {
        url += '&live_music=1';
        this.setHidden('live_music', 1);
      }
      return [location.protocol, '//', location.host, location.pathname].join('') + '?' + url.replace(/^&/, '');
    },
    filterSubmit: function () {
      this.setURL();

      $('form.views-exposed-form :input[name*=filtered]').val('1');
      $('form.views-exposed-form input.form-submit').click();
      $('form.views-exposed-form :input[name*=filtered]').val('0');
    },


    attach: function () {
      $('#edit-start-date').attr('type', 'date');
      $('#edit-end-date').attr('type', 'date');
      var urlRegion = $.QueryString.region;
      var urlSubRegion = $.QueryString.subregion;
      var urlCity = $.QueryString.city;
      var urlStartDate = $.QueryString.start_date;
      var urlEndDate = $.QueryString.end_date;
      var urlCat = $.QueryString.category;
      var urlFF = $.QueryString.family_friendly;
      var urlLM = $.QueryString.live_music;
      var arr = [];
      if (urlStartDate) {
        arr = urlStartDate.split('/');
        urlStartDate = '20' + arr[2] + '-' + arr[0] + '-' + arr[1];
        $('#edit-end-date').attr('min', urlStartDate);
      }

      if (urlEndDate) {
        arr = urlEndDate.split('/');
        urlEndDate = '20' + arr[2] + '-' + arr[0] + '-' + arr[1];
        $('#edit-start-date').attr('max', urlEndDate);
      }

      function handleDateChange(dateType) {
        return function () {
          var arr = $(this).val().split('-');
          if (arr.length > 1) {
            var d = arr[1] + '/' + arr[2] + '/' + arr[0].slice(-2);
            $('form.views-exposed-form .form-item-' + dateType + '-date input').val(d);
            if (dateType === 'start') {
              var toDate = new Date($('form.views-exposed-form .form-item-end-date input').val());
              var fromDate = new Date($(this).val());
              if (fromDate.getTime() > toDate.getTime()) {
                $('form.views-exposed-form .form-item-end-date input').val('');
              }
            }
            $('#edit-start-date').attr('disabled', 'TRUE');
            $('#edit-end-date').attr('disabled', 'TRUE');
            $('#edit-start-date').addClass('disabled');
            $('#edit-end-date').addClass('disabled');
            $('.pselect-wrapper').addClass('disabled');

            dataLayer.push({
              eventCategory: 'calendar',
              eventAction: 'date ' + (dateType === 'start' ? 'from' : 'to'),
              eventLabel: $(this).val(),
              eventvalue: '',
              event: 'eventClick'
            });

            Drupal.behaviors.calendar.filterSubmit();
          }
          else {
            $('form.views-exposed-form .form-item-' + dateType + '-date input').val('');
            Drupal.behaviors.calendar.filterSubmit();
          }
        };
      }

      var handleStartDateChange = handleDateChange('start');
      var handleEndDateChange = handleDateChange('end');

      var debouncedStartDateChange = debounce(handleStartDateChange, 3000);
      var debouncedEndDateChange = debounce(handleEndDateChange, 3000);

      $(once('startdate', '#edit-start-date')).each(function () {
        var $this = $(this);
        var originalValue = $this.val();

        $this.change(debouncedStartDateChange)
          .on('focus', function () {
            originalValue = $this.val();
          })
          .on('blur', function () {
            if ($this.val() !== originalValue) {
              handleStartDateChange.call(this);
            }
          });
      });

      $(once('enddate', '#edit-end-date')).each(function () {
        var $this = $(this);
        var originalValue = $this.val();

        $this.change(debouncedEndDateChange)
          .on('focus', function () {
            originalValue = $this.val();
          })
          .on('blur', function () {
            if ($this.val() !== originalValue) {
              handleEndDateChange.call(this);
            }
          });
      });

      var urlLocation = '';
      if (urlRegion) {
        urlLocation = urlRegion;
      }
      else if (urlSubRegion) {
        urlLocation = urlSubRegion;
      }
      else if (urlCity) {
        urlLocation = urlCity;
      }


      var location_field = $('.block-tnv-calendar-filters-form .form-item-location:not(.tp-processed)');

      if (location_field.length > 0) {
        location_field.addClass('processed').pSelect(
          {
            default: urlLocation,
            searchElement: $('.block-tnv-calendar-filters-form .form-item-city-search'),
            onChange: function (option) {
              if (option.data('filterType') === 'cities') {
                // Clear region filters
                $('form.views-exposed-form select[name*=region]').val([]);
                // Clear subregion filters
                $('form.views-exposed-form select[name*=subregion]').val([]);
                // Set City Filters
                $('form.views-exposed-form input[name*=city]').val(option.data('filterValue'));
                $('#edit-start-date').attr('disabled', 'TRUE');
                $('#edit-end-date').attr('disabled', 'TRUE');
                $('#edit-start-date').addClass('disabled');
                $('#edit-end-date').addClass('disabled');
                $('.pselect-wrapper').addClass('disabled');
                // Submit form.
                Drupal.behaviors.calendar.filterSubmit();
              }
              else if (option.data('filterType') === 'regions') {
                // Clear City filters.
                $('form.views-exposed-form input[name*=city]').val('');
                // Clear subregion filters
                $('form.views-exposed-form select[id=edit-subregion-1]').val([]);
                // Set Region filters.
                setMultiWithChildren($('form.views-exposed-form select[id=edit-region-1]'), option.data('filterValue'));
                $('#edit-start-date').attr('disabled', 'TRUE');
                $('#edit-end-date').attr('disabled', 'TRUE');
                $('#edit-start-date').addClass('disabled');
                $('#edit-end-date').addClass('disabled');
                $('.pselect-wrapper').addClass('disabled');
                // Submit form.
                Drupal.behaviors.calendar.filterSubmit();
              }
              else if (option.data('filterType') === 'subregions') {
                // Clear City filters.
                $('form.views-exposed-form input[name*=city]').val('');
                // Clear region filters
                $('form.views-exposed-form select[id=edit-region-1]').val([]);
                // Set subregion filters.
                setMultiWithChildren($('form.views-exposed-form select[id=edit-subregion-1]'), option.data('filterValue'));
                $('#edit-start-date').attr('disabled', 'TRUE');
                $('#edit-end-date').attr('disabled', 'TRUE');
                $('#edit-start-date').addClass('disabled');
                $('#edit-end-date').addClass('disabled');
                $('.pselect-wrapper').addClass('disabled');
                // Submit form.
                Drupal.behaviors.calendar.filterSubmit();
              }
            },
            onClear: function () {
              // Clear City filters.
              $('form.views-exposed-form input[name*=city]').val('');
              // Clear region filters
              $('form.views-exposed-form select[name*=region]').val([]);
              // Clear subregion filters
              $('form.views-exposed-form select[name*=subregion]').val([]);
              $('#edit-start-date').attr('disabled', 'TRUE');
              $('#edit-end-date').attr('disabled', 'TRUE');
              $('#edit-start-date').addClass('disabled');
              $('#edit-end-date').addClass('disabled');
              $('.pselect-wrapper').addClass('disabled');
              // Submit form.
              Drupal.behaviors.calendar.filterSubmit();
            }
          }
        );
      }


      $('form#block-tnv-calendar-filters-form input[name^=start_date]:not(.url_processed)').addClass('url_processed').val(urlStartDate ? urlStartDate : '');
      $('form#block-tnv-calendar-filters-form input[name^=end_date]:not(.url_processed)').addClass('url_processed').val(urlEndDate ? urlEndDate : '');

      var child_field = $('.block-tnv-calendar-filters-form .form-item-category-child:not(.tp-processed)');

      if (child_field.length > 0) {
        child_field.addClass('processed').pSelect(
          {
            default: urlCat,
            disabled: false,
            onChange: function (option) {
              $('form.views-exposed-form select[name^=content_category]').val(option.data('filterValue'));
              $('#edit-start-date').attr('disabled', 'TRUE');
              $('#edit-end-date').attr('disabled', 'TRUE');
              $('#edit-start-date').addClass('disabled');
              $('#edit-end-date').addClass('disabled');
              $('.pselect-wrapper').addClass('disabled');
              // Submit form.
              Drupal.behaviors.calendar.filterSubmit();
            },
            onClear: function (plugin) {
              // Reset to parent value.
              setMultiWithChildren($('form.views-exposed-form select[name^=content_category]'), plugin.settings.optGroupId);
              $('form.views-exposed-form :input[name*=content_category]').val([]);
              $('#edit-start-date').attr('disabled', 'TRUE');
              $('#edit-end-date').attr('disabled', 'TRUE');
              $('#edit-start-date').addClass('disabled');
              $('#edit-end-date').addClass('disabled');
              $('.pselect-wrapper').addClass('disabled');
              // Submit form.
              Drupal.behaviors.calendar.filterSubmit();
            }
          }
        );
      }
      $('form#block-tnv-calendar-filters-form .opt-group-children').addClass('active');

      // Set Family Friendly filters.
      $('form#block-tnv-calendar-filters-form input[name^=family]:not(.url_processed)').addClass('url_processed').prop('checked', (urlFF === '1') ? true : false);

      $('form#block-tnv-calendar-filters-form input[name^=family]').on('change', function (e) {
        $('form.views-exposed-form select[name^=family]').val($(this).is(':checked') ? 1 : 'All');
        $('#edit-start-date').attr('disabled', 'TRUE');
        $('#edit-end-date').attr('disabled', 'TRUE');
        $('#edit-start-date').addClass('disabled');
        $('#edit-end-date').addClass('disabled');
        $('.pselect-wrapper').addClass('disabled');
        // Submit form.
        Drupal.behaviors.calendar.filterSubmit();
      });

      // SetLive Music filters.
      $('form#block-tnv-calendar-filters-form input[name^=live]:not(.url_processed)').addClass('url_processed').prop('checked', (urlLM === '1') ? true : false);

      $('form#block-tnv-calendar-filters-form input[name^=live]').on('change', function (e) {
        $('form.views-exposed-form select[name^=live]').val($(this).is(':checked') ? 1 : 'All');
        $('#edit-start-date').attr('disabled', 'TRUE');
        $('#edit-end-date').attr('disabled', 'TRUE');
        $('#edit-start-date').addClass('disabled');
        $('#edit-end-date').addClass('disabled');
        $('.pselect-wrapper').addClass('disabled');
        // Submit form.
        Drupal.behaviors.calendar.filterSubmit();
      });

      // Disable form submission on the fake filter form.
      $('#block-tnv-calendar-filters-form').submit(function (e) {e.preventDefault();});

      $('.custom-select-display-value').click(function (e) {
        $('.custom-select-wrapper').removeClass('active');
        $(this).closest('div').addClass('active');
        e.preventDefault();
      });

      $('.custom-select-options a').click(function (e) {
        var text = $(e.target).text();
        $(this).parents('.custom-select-wrapper').find('.custom-select-display-value').html(text);
        $(this).closest('.custom-select-wrapper').removeClass('active');
      });

      $(document).on('click', function (e) {
        if ($(e.target).parents('.custom-select').length === 0) {
          $('.custom-select-wrapper').removeClass('active');
        }
      });


      // Added placeholders to date fields in calendar form.
      const urlParams = new URLSearchParams(window.location.search);
      const start_value = urlParams.get('start_date');
      const end_value = urlParams.get('end_date');

      if ((window.location.href.indexOf('&end_date') === -1) || (end_value === '')) {
        $('.block-tnv-calendar-filters-form #edit-end-date').addClass('end-placeholder');
      }

      if ((window.location.href.indexOf('&start_date') === -1) || (start_value === '')) {
        $('.block-tnv-calendar-filters-form #edit-start-date').addClass('start-placeholder');
      }

      $('.block-tnv-calendar-filters-form #edit-end-date').click(function () {

        $(this).removeClass('end-placeholder');

      });

      $('.block-tnv-calendar-filters-form #edit-start-date').click(function () {

        $(this).removeClass('start-placeholder');

      });
    }
  };
})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef
